import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

const FileTaxonomiesExpandSwitch = ({
  handleSwitchAllTaxonomies,
  allTaxonomiesExpanded,
}) => {
  const intl = useIntl();

  return (
    <Button
      type="button"
      color="link"
      onClick={handleSwitchAllTaxonomies}
      className="file-detail-title file-detail-header-button"
    >
      {allTaxonomiesExpanded ? (
        intl.formatMessage({ defaultMessage: 'Collapse all' })
      ) :
        intl.formatMessage({ defaultMessage: 'Expand all' })}
    </Button>
  );
};

FileTaxonomiesExpandSwitch.propTypes = {
  allTaxonomiesExpanded: PropTypes.bool.isRequired,
  handleSwitchAllTaxonomies: PropTypes.func.isRequired,
};

export default FileTaxonomiesExpandSwitch;
